import React from "react";
import PropTypes from "prop-types";
import { SvgIconHandler } from "../../../../atoms/SvgIconHandler";
import "./faq-item.m.css";

export const FaqItem = ({ title, content, isExpanded, onToggle, id, setExpandedId }) => {
  return (
    <article styleName="faq-item">
      {isExpanded && <hr styleName="divider-top" />}
      <div styleName={`${isExpanded ? "item-expanded" : "faq-item-content"}`}>
        {content && isExpanded && (
          <div styleName="faq-item-text">
            <div styleName="faq-item-text-inner">
              <div styleName="text-div">
                <h3 styleName="faq-qn">{title}</h3>
                <span
                  styleName="chevron"
                  style={{
                    transform: isExpanded ? "rotate(180deg)" : "rotate(360deg)",
                  }}
                  onClick={() => setExpandedId((prev) => !prev)}
                >
                  <SvgIconHandler type="arrow" width="16" height="16" viewBox="0 0 16 16" />
                </span>
              </div>
              <p styleName="block-text">{content}</p>
            </div>
          </div>
        )}
        <div styleName="faq-item-header">
          {!isExpanded && <hr styleName="divider-bottom" />}
          {!isExpanded && (
            <button
              styleName="faq-item-title"
              onClick={onToggle}
              aria-expanded={isExpanded}
              aria-controls={`faq-content-${id}`}
            >
              <span styleName="title">{title}</span>
              <span
                styleName="chevron"
                style={{
                  transform: !isExpanded ? "rotate(360deg)" : "rotate(180deg)",
                }}
              >
                <SvgIconHandler type="arrow" width="16" height="16" viewBox="0 0 16 16" />
              </span>
            </button>
          )}
        </div>
      </div>
    </article>
  );
};

FaqItem.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
